import Vue from 'vue'
import Router from 'vue-router'
import main from '@/components/main'
import edit from '@/components/edit'
//平台路由
import base from './base.js'
Vue.use(Router)

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'main',
      component: main
    },
    {
      path: '/edit',
      name: 'edit',
      component: edit
      
    },
    base
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js